import styled, {css} from 'styled-components';

import BaseSuccessIcon from '@edna/icons/success.svg';

import BaseTextInput from '../TextInput';
import {Stack} from '../primitives';
import {mixins} from '../styles';

type TImageContainerProps = TTheme & {
  readOnly?: boolean;
  isInvalid?: boolean;
};

const Image = styled.label<TImageContainerProps>`
  ${mixins.stack({size: '1', align: 'center', justify: 'center'})};
  ${mixins.wh('117px')};
  ${mixins.f4};
  position: relative;
  text-align: center;
  overflow: hidden;
  ${({theme, isInvalid, readOnly}) => css`
    color: ${theme.palette.grey400};
    background-color: ${isInvalid ? theme.palette.red100 : theme.palette.grey50};
    border: ${theme.spacing.s05} solid ${isInvalid ? theme.palette.red400 : theme.palette.grey400};
    border-radius: ${theme.borderRadius.br2};
    transition: box-shadow ${theme.animation.duration}ms;
    box-shadow: ${theme.boxShadow.S};

    &:hover,
    &:active {
      cursor: pointer;
      pointer-events: ${readOnly ? 'none' : 'auto'};
    }
  `}

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const ImageContainer = styled(Stack).attrs({size: '2', justify: 'center'})`
  max-width: 117px;
`;

type TOkIconProps = TTheme & {
  readOnly?: boolean;
};

const SuccessIcon = styled(BaseSuccessIcon)`
  ${mixins.wh('20px')};
  flex-shrink: 0;
  ${({theme: {palette}, readOnly}: TOkIconProps) => css`
    color: ${readOnly ? palette.grey400 : palette.green500};
  `}
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  column-gap: ${({theme}) => theme.spacing.s4};
`;

const TextInput = styled(BaseTextInput)`
  width: 100%;
`;

const SecondaryText = styled.div`
  ${mixins.f3}
  color: ${({theme}) => theme.branding.content.secondary};
`;

const Hint = styled.span`
  ${mixins.f2}
  color: ${({theme}) => theme.branding.content.secondary};
`;

const ImageName = styled(SecondaryText)`
  word-break: break-all;
`;

const GrowStack = styled(Stack).attrs({size: '2'})`
  flex-grow: 1;
`;

export {
  GrowStack,
  SecondaryText,
  Hint,
  ImageContainer,
  Image,
  SuccessIcon,
  ImageName,
  Wrapper,
  TextInput,
};
